import { isNull } from '@/utils/comparators'

const getters = {
  getStartpage: state => (take) => {
    return state.startpage.slice(0, take)
  },

  getCategories: (state) => {
    state.categories
  },

  getMaterialCategories: state => state.materialCategories,

  getCategoryBySlug: state => (slug) => {
    const filtered = state.categories.filter(c => c.slug === slug)
    return filtered.length > 0 ? filtered[0] : {}
  },

  getMaterialCategoryBySlug: state => (slug) => {
    const filtered = state.materialCategories.filter(c => c.slug === slug)
    return filtered.length > 0 ? filtered[0] : {}
  },

  getArticle: state => (slug, locale = 'en') => {
    if (!state.articles[locale]) {
      return undefined
    }
    return state.articles[locale][slug]
  },
  getFeatured: state => (categoryId = 'start') => {
    return (state.articleLists[categoryId] && state.articleLists[categoryId].featured.length > 0)
      ? state.articleLists[categoryId].featured[0]
      : null
  },
  getArticles: state => (take, categoryId = 'start') => {
    const featured = state.articleLists[categoryId].featured.length > 0
      ? state.articleLists[categoryId].featured[0]
      : null

    return isNull(featured)
      ? state.articleLists[categoryId].articles.slice(0, take)
      : state.articleLists[categoryId].articles.slice(0, take).filter(a => a.id !== featured.id)
  },

  hasMore: state => (asked, categoryId = 'start') => {
    const featured = state.articleLists[categoryId].featured.length > 0
      ? state.articleLists[categoryId].featured[0]
      : null
    return isNull(featured)
      ? asked < state.articleLists[categoryId].count
      : asked < state.articleLists[categoryId].count - 1
  },

  getMaterials: state => (take, materialsCategoryId) => {
    return state.materialLists[materialsCategoryId].materials.slice(0, take)
  },

  hasMoreMaterials: state => (asked, materialsCategoryId) => {
    return asked < state.materialLists[materialsCategoryId].count
  },

  getTagBySlug: state => (slug) => {
    return state.tags[slug]
  },

  getArticlesByTag: state => (take, slug) => {
    return state.tags[slug].articles.slice(0, take)
  },

  hasMoreArticlesInTag: state => (asked, slug) => {
    return asked < state.tags[slug].count
  }
}

export default getters
